import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthWebService } from 'app/services/authweb.service';
import { CountryService } from 'app/services/country.service';
import { MonthlyComplianceService } from 'app/services/monthly-compliance.service';
import { PassengerListServiceService } from "app/services/passenger-list-service.service";
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ImportService } from "app/services/import.service";
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-passenger-list',
  templateUrl: './passenger-list.component.html',
  styleUrls: ['./passenger-list.component.scss']
})
export class PassengerListComponent implements OnInit {

  isLoading: boolean = false;
  tripId;
  listPassengersFromDB: any = [];
  listPassengers: any[] = [];
  sortDir = 1;
  user: any = {};
  ddlCountries = [];
  selectedCountryId: number = 113;
  selectedPassenger: any = {};
  tripDetails: any = {};
  tripDate: string = "";
  isReturnTrip: boolean = true;
  forward_trip_id: number = 0;
  permit_id: any;
  carrier_id: any;
  compliance_return_id: any;
  isAdmin: boolean = false;

  constructor(

    private _activatedRoute: ActivatedRoute,
    private monthlyComplianceService: MonthlyComplianceService,
    private passengerListServiceService: PassengerListServiceService,
    private authWebService: AuthWebService,
    private countryService: CountryService,
    private toastService: ToastNotificationService,
    private http: HttpClient,
    private importService : ImportService,
    private _router: Router,
    private confirmDialogService: ConfirmDialogService,
  ) { }

  
  ngOnInit(): void {
    this.isLoading = true;
  this.tripId = this._activatedRoute.snapshot.paramMap.get("id");
  this.carrier_id = this._activatedRoute.snapshot.paramMap.get("carrierid");
  this.permit_id = this._activatedRoute.snapshot.paramMap.get("permitid");
  this.compliance_return_id = this._activatedRoute.snapshot.paramMap.get("compliancereturnid");
  if (this.tripId) this.getList();
  this.user = this.authWebService.userData
  ? this.authWebService.userData.User
  : null;

  this.listCountries();
  this.getTripDetails();

  this.isLoading = false;
  if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
    this.isAdmin = true;

}
  
  }

  getList() {
    
    //let url = `/${this.currentPage}/${this.pageSize}`;
    this.passengerListServiceService.getPassengersByTripId(this.tripId).subscribe(
      (res: any) => {
      this.listPassengersFromDB = res;
        
      },
      (err) => {
        console.error(err);
        
      }
    );
  }

  getTripDetails() {
    
    this.passengerListServiceService.getTripDetails(this.tripId).subscribe(
      (res: any) => {
      this.tripDetails = res;
      console.log("TripDetails", this.tripDetails);
      this.forward_trip_id = this.tripDetails.forward_trip_id;
      const calendarDate: string = this.tripDetails.calendar?.calendar_date || '';
      this.tripDate = calendarDate.split('T')[0];

      // this.compliance_return_id = this.tripDetails.compliance_return_id;

      // this.passengerListServiceService.getReturnDetails(this.compliance_return_id).subscribe(
      //   (res: any) => {
      //     console.log("Compliance Return Id", res);
      //     // this.permit_id = res.permit_id;
      //     // this.carrier_id = res.carrier_id;
      //
      //   });

      if(this.forward_trip_id > 0){
        this.isReturnTrip = true;
      }
      else{
        this.isReturnTrip = false;
      }

      this.isLoading = false;
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onSortClick(colName, event) {
    let target = event.currentTarget,
      classList = target.classList;
    if (classList.contains("fa-chevron-circle-up")) {
      classList.remove("fa-chevron-circle-up");
      classList.add("fa-chevron-circle-down");
      this.sortDir = -1;
    } else {
      classList.add("fa-chevron-circle-up");
      classList.remove("fa-chevron-circle-down");
      this.sortDir = 1;
    }
    this.sortArr(colName);
  }

  sortArr(colName: any) {
    this.listPassengersFromDB.sort((a, b) => {
      a = a[colName].toLowerCase();
      b = b[colName].toLowerCase();
      return a.localeCompare(b) * this.sortDir;
    });
  }

  actionClicked(optionVal, res) {
   // this.ocausId = res.id;
    switch (optionVal) {
      // Permits
      case 0:
        // this.utility.isfromCarrier = false;
        // this.viewAcc(res, "/carrier/permit/application/mypermits");
        break;
      // Applications
      case 1:
        this.confirmDialogService.confirmThis(
          "Are you sure you want to delete? You're about to delete this passenger",
          () => {
            this.delete(res.id);
          },
          () => {
            return;
          }
        );

        break; 
      default:
        break;
    }
  }



listCountries = () => {

  this.countryService.listCountries().subscribe((result: any) => {
      this.ddlCountries = result.map(({ id, desc }) => ({ id, desc }))
      
      //console.log(this.ddlCountries);
  }, error => {
      
      //console.log(error);
  });
}




onSaveClick(): void {
  // Retrieve the input values and save logic
}

// Other component methods

savePassenger(): void {
  // Retrieve the input values
  const firstName = (<HTMLInputElement>document.getElementsByName('first-name')[0]).value;
  const lastName = (<HTMLInputElement>document.getElementsByName('lastname')[0]).value;
  const nationalitySelect = document.querySelector('select') as HTMLSelectElement;
  const selectedIndex = nationalitySelect.selectedIndex;
  const nationalityId = nationalitySelect.options[selectedIndex].value;
  const country_id = nationalityId.split(":")[1].trim();
  const identity = (<HTMLInputElement>document.getElementsByName('identity')[0]).value;
  const passport_number = (<HTMLInputElement>document.getElementsByName('passport_number')[0]).value;
  const cellphone = (<HTMLInputElement>document.getElementsByName('cellphone')[0]).value;

  // Create a new passenger object
  const newPassenger = {
    compliance_trip_id: this.tripId,
    first_name: firstName,
    last_name: lastName,
    passport_country_id: country_id,
    id_number: identity,
    passport_number:passport_number,
    cellphone: cellphone
  };

          //Check if data filled correctly
          if(newPassenger.id_number == "" && newPassenger.passport_number == ""){
            this.toastService.error('Please make sure you have ID Number or Passport Number, then try again', 'Passenger List');
            return;       
          }
          if(newPassenger.first_name == ""){
            this.toastService.error('Please make sure you have a name, then try again', 'Passenger List');
            return;       
          }
          if(newPassenger.last_name == ""){
            this.toastService.error('Please make sure you have a surname, then try again', 'Passenger List');
            return;       
          }
          if(newPassenger.cellphone == ""){
            this.toastService.error('Please make sure you have a next of kin phone number, then try again', 'Passenger List');
            return;       
          }

  // Save the new passenger
  this.listPassengers.push(newPassenger);

  // Reset the input fields
  (<HTMLInputElement>document.getElementsByName('first-name')[0]).value = '';
  (<HTMLInputElement>document.getElementsByName('lastname')[0]).value = '';
  (<HTMLInputElement>document.getElementsByName('identity')[0]).value = '';
  (<HTMLInputElement>document.getElementsByName('cellphone')[0]).value = '';
  (<HTMLInputElement>document.getElementsByName('passport_number')[0]).value = '';
  // Call the service to save the passenger
  this.passengerListServiceService.savePassenger(newPassenger).subscribe(
    (result) => {
      if (this.tripId) this.getList();
      this.toastService.success('Passenger added successfully.', 'Passenger List');
    },
    (error) => {
      // Handle error
      
      this.toastService.error('Passenger could not be added. Please contact the system administrator if the problem persists.' + '\nTel : 012 471 2121\'+\'\nEmail: helpdesk@cbrta.co.za', 'Passenger List')
    }
  );
}

submitPassengerList(): void{
  
}

importTrip(): void{
  
}

download() {
  const filePath = 'assets/PassengerList.xlsx';
  this.http.get(filePath, { responseType: 'blob' }).subscribe((blob) => {
    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = 'PassengerList.xlsx';
    downloadLink.click();
    window.URL.revokeObjectURL(url);
  });
}

copyFromForward(): void{
  this.getPassengersFromForwardTrip();
  
}

delete(id : number): void{
  this.passengerListServiceService.deletePassenger(id).subscribe(
    (result) => {
      if (this.tripId) this.getList();
      this.toastService.success('Passenger deleted successfully.', 'Passenger List');
    },
    (error) => {
      // Handle error
      
      this.toastService.error('Passenger could not be deleted. Please contact the system administrator if the problem persists.' + '\nTel : 012 471 2121\'+\'\nEmail: helpdesk@cbrta.co.za', 'Passenger List')
    }
  );
}

assignSelected(passenger: any): void{

  this.selectedPassenger = passenger;
}

updatePassenger(): void {

  // Call the service to save the passenger
  this.passengerListServiceService.updatePassenger(this.selectedPassenger).subscribe(
    (result) => {
      if (this.tripId) this.getList();
      this.toastService.success('Passenger updated successfully.', 'Passenger List');
    },
    (error) => {
      // Handle error
      
      this.toastService.error('Passenger could not be updated. Please contact the system administrator if the problem persists.' + '\nTel : 012 471 2121\'+\'\nEmail: helpdesk@cbrta.co.za', 'Passenger List')
    }
  );
}

public async handleFileUpload(event: Event): Promise<void> {

  const file = (event.target as HTMLInputElement).files[0];
    // Check the file extension to see if it's an Excel file
    const allowedExtensions = ['.xlsx', '.xls', '.csv'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!allowedExtensions.includes(`.${fileExtension}`)) {
      this.toastService.error('You are trying to upload a wrong file.Please download the template and fill in your details, then try again', 'Passenger List');
      return;
    }

  if (file) {
    try {
      const data = await this.importService.importDataFromExcel(file);
      //Default to South Africa
      let countryId = 113;
      let logMessages: string = '';

      for (const dataItem of data) {

        //Check if data filled correctly
        if(dataItem.IDNumber === undefined && dataItem.PassportNumber === undefined){
          this.toastService.error('Please make sure you have ID Number or Passport Number for all passengers, then try again', 'Passenger List');
          return;       
        }
        if(dataItem.Name === undefined){
          this.toastService.error('Please make sure you have a name for all passengers, then try again', 'Passenger List');
          return;       
        }
        if(dataItem.Surname === undefined){
          this.toastService.error('Please make sure you have a surname for all passengers, then try again', 'Passenger List');
          return;       
        }
        if(dataItem.TelephoneOfNextOfKin === undefined){
          this.toastService.error('Please make sure you have a next of kin phone number for all passengers, then try again', 'Passenger List');
          return;       
        }

        //Validations
        const isIDNumberExists = this.listPassengersFromDB.some((passenger) => passenger.id_number === dataItem.IDNumber);
        if (isIDNumberExists) {
          logMessages +=`ID Number ${dataItem.IDNumber} already exists for this trip.`;
          continue;
        }
        const isPassportExists = this.listPassengersFromDB.some((passenger) => passenger.passport_number === dataItem.PassportNumber);
        if (isPassportExists) {
          logMessages +=`Passport Number ${dataItem.PassportNumber} already exists for this trip.`;
          continue;
        }

          const foundId = this.getIdByDesc(dataItem.Nationality);

          if (foundId !== undefined) {
            countryId = foundId;
          } 
        const newPassenger = {
          compliance_trip_id: this.tripId,
          first_name: dataItem.Name,
          last_name: dataItem.Surname,
          passport_country_id: countryId,
          id_number: dataItem.IDNumber,
          passport_number:dataItem.PassportNumber,
          cellphone: dataItem.TelephoneOfNextOfKin
        };

        this.passengerListServiceService.savePassenger(newPassenger).subscribe(
          (result) => {
            if (this.tripId) this.getList();
          },
          (error) => {
            // Handle error
            
          }
        );
        
      }
      if (this.tripId) this.getList();
      if (logMessages.length === 0) {
        this.toastService.success('Passengers added successfully.', 'Passenger List');
      } else {
        this.toastService.error(logMessages, 'Passenger List');
      }


    } catch (error) {
      console.error('Error importing data:', error);
    }
  }
}

getIdByDesc = (descToFind: string): number | undefined => {
  const matchedItem = this.ddlCountries.find((item) => item.desc === descToFind);
  return matchedItem ? matchedItem.id : undefined;
};

getPassengersFromForwardTrip() {
  
  
  //let url = `/${this.currentPage}/${this.pageSize}`;
  this.passengerListServiceService.getPassengersByTripId(this.forward_trip_id).subscribe(
    (res: any) => {

      let logMessages: string = '';
      let count = 0;

      for (let i = 0; i < res.length; i++) {
        const element = res[i];

            const isIDNumberExists = this.listPassengersFromDB.some((passenger) => passenger.id_number === element.id_number);
            if (isIDNumberExists) {
              logMessages +=`ID Number ${element.id_number} already exists for this trip.`;
              continue;
            }
            const isPassportExists = this.listPassengersFromDB.some((passenger) => passenger.passport_number === element.passport_number);
            if (isPassportExists) {
              logMessages +=`Passport Number ${element.passport_number} already exists for this trip.`;
              continue;
            }

              const newPassenger = {
                compliance_trip_id: this.tripId,
                first_name: element.first_name,
                last_name: element.last_name,
                passport_country_id: element.passport_country_id,
                id_number: element.id_number,
                passport_number:element.passport_number,
                cellphone: element.cellphone
              };

              this.passengerListServiceService.savePassenger(newPassenger).subscribe(
                (result) => {

                },
                (error) => {
                  // Handle error
                  
                }
              );

              count = count + 1;

    };

    //After Adding
    if (logMessages.length === 0) {
      if(count == 0){
        this.toastService.error('No passengers imported from forward trip.', 'Passenger List');
        if (this.tripId) this.getList();
      }
      else{
        this.toastService.success('Passengers imported successfully.', 'Passenger List');
        if (this.tripId) this.getList();
      }

    } else {
      this.toastService.error(logMessages, 'Passenger List');
    }
      
    },
    (err) => {
      console.error(err);
      
    }
  );
}

back()
{

  this._router.navigate(['carrier/monthly-returns/'+ this.carrier_id + "/" + this.permit_id+ "/" + this.compliance_return_id]);
 // this._router.navigate([`/admin-annual-compliance/application/${this.details_Id}`]);
  
}

}
